// LOGIN
export const loginApiReducer = (state = {}, action) => {
    switch (action.type) {
        case "LOGIN_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "LOGIN_SUCCESS":
            return {
                ...state,
                loading: false,
                loginApiData: action.payload,
            };
        case "LOGIN_RESET":
            return {
                ...state,
                loginApiData: null,
                error: null
            };
        case "LOGIN_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}

// signup
export const signUpApiReducer = (state = {}, action) => {
    switch (action.type) {
        case "SIGNUP_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "SIGNUP_SUCCESS":
            return {
                ...state,
                loading: false,
                signUpApiData: action.payload,
            };
        case "SIGNUP_RESET":
            return {
                ...state,
                signUpApiData: null,
                error: null
            };
        case "SIGNUP_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}

// Forgot Password
export const forgotApiReducer = (state = {}, action) => {
    switch (action.type) {
        case "FORGOT_PASSWORD_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "FORGOT_PASSWORD_SUCCESS":
            return {
                ...state,
                loading: false,
                forgotApiData: action.payload,
            };
        case "FORGOT_PASSWORD_RESET":
            return {
                ...state,
                forgotApiData: null,
                error: null
            };
        case "FORGOT_PASSWORD_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}

// Reset Password
export const resetPasswordApiReducer = (state = {}, action) => {
    switch (action.type) {
        case "RESET_PASSWORD_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "RESET_PASSWORD_SUCCESS":
            return {
                ...state,
                loading: false,
                resetApiData: action.payload,
            };
        case "RESET_PASSWORD_RESET":
            return {
                ...state,
                resetApiData: null,
                error: null
            };
        case "RESET_PASSWORD_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}